<template>
  <v-container>
    <v-row>
      <ViewHeader :title="$t('message.reviewBooster.formList.title')" />
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <v-card class="card">
          <p class="description">
            {{ $t("message.reviewBooster.formList.description") }}
          </p>
          <FormDatagrid />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ViewHeader from "@/components/ui/ViewHeader";
import FormDatagrid from "@/components/ReviewBooster/FormDatagrid.vue";

export default {
  name: "ReviewBoosterFormList",
  components: {
    ViewHeader,
    FormDatagrid
  }
};
</script>

<style lang="scss" scoped>
.description {
  @include font-size(14px);
  margin: $spacing 0 $spacing * 8 0;
}
.card {
  min-height: 589px;
  position: relative;
  padding: $spacing * 3;
}
</style>
